var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDosageSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.724 4.53658C11.659 3.26735 9.76679 3.1018 8.49756 4.1668L6.07177 6.20231L3.64595 8.23781C2.37673 9.3028 2.21117 11.1951 3.27618 12.4643C4.34119 13.7335 6.23345 13.8991 7.50268 12.8341L12.3543 8.76306C13.6235 7.69806 13.7891 5.8058 12.724 4.53658ZM7.85478 3.40076C9.54708 1.98075 12.0701 2.20149 13.4901 3.89379C14.9101 5.5861 14.6894 8.10911 12.9971 9.52911L8.14547 13.6001C6.45316 15.0201 3.93015 14.7994 2.51013 13.1071C1.09013 11.4148 1.31086 8.89176 3.00316 7.47176L7.85478 3.40076Z",
    fill: "#87928A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24112 7.4041C6.45266 7.2266 6.76804 7.25419 6.94554 7.46573L8.85807 9.74503C9.03557 9.95657 9.00797 10.2719 8.79644 10.4494C8.5849 10.6269 8.26952 10.5994 8.09202 10.3878L6.17949 8.10851C6.00199 7.89697 6.02958 7.5816 6.24112 7.4041Z",
    fill: "#87928A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDosageSmall);
export default __webpack_public_path__ + "static/media/dosage-small.d6ee38e106f8927eeb6785496c548224.svg";
export { ForwardRef as ReactComponent };